import { render, staticRenderFns } from "./carts_items.vue?vue&type=template&id=13ae147e&"
import script from "./carts_items.vue?vue&type=script&lang=js&"
export * from "./carts_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports